import { Container, Row } from "reactstrap";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";

const BuyerData = () => {
  return (
    <>
      <Container className="basic_table" fluid>
        <Breadcrumbs
          mainTitle={"Buyer Data"}
          parent={"Report"}
          title={"Buyer Data"}
        />
        {/* <Row></Row> */}
      </Container>
    </>
  );
};

export default BuyerData;
